import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    region:
      window.__RUNTIME_CONFIG__.REACT_APP_COGNITO_REGION || import.meta.env.VITE_COGNITO_REGION,
    userPoolId:
      window.__RUNTIME_CONFIG__.REACT_APP_USER_POOL_ID || import.meta.env.VITE_USER_POOL_ID,
    userPoolWebClientId:
      window.__RUNTIME_CONFIG__.REACT_APP_USER_POOL_WEB_CLIENT_ID ||
      import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
  },
});
